import angular from 'angular';

(function () {
    'use strict';

    angular.module('app.core').service('linkRequestSvc', linkRequestSvc);

    linkRequestSvc.$inject = ['$sessionStorage','linkRequestDA'];

    /* @ngInject */
    function linkRequestSvc($sessionStorage,linkRequestDA) {
        var exports = {
            getLinkRequests: getLinkRequests,
            getLinkRequestExport:getLinkRequestExport,
            getLinkRequestCount:getLinkRequestCount,
            searchSubEntitiesByNameOrCode:searchSubEntitiesByNameOrCode,
        };

        return exports;

        /**
         * fournit si une entité invité apartient a une communité ou pas .
         */
        function getLinkRequests(invitedEntityId ,invitedBuyerLinkRequestFilter, sens) {
            $sessionStorage.invitedBuyerLinkRequestFilter = invitedBuyerLinkRequestFilter;
            var filter = invitedBuyerLinkRequestFilter.prepareBeforeSearch();
            return linkRequestDA.getLinkRequestList(invitedEntityId , sens ,filter);
        }

        function getLinkRequestExport( invitedBuyerLinkRequestFilter,format, invitedBuyerId, sens) {
            $sessionStorage.invitedBuyerLinkRequestFilter = invitedBuyerLinkRequestFilter;
            var filter = invitedBuyerLinkRequestFilter.prepareBeforeSearch();
            return linkRequestDA.getLinkRequestExport(filter, format ,invitedBuyerId, sens)
        }
        function getLinkRequestCount(invitedBuyerId, sens){
            return linkRequestDA.getLinkRequestCount(invitedBuyerId, sens);
        }
        function searchSubEntitiesByNameOrCode(searchValue){
            return linkRequestDA.searchSubEntitiesByNameOrCode(searchValue);
        }
    }
})();
